var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-icon',{staticClass:"cursor-pointer secondary-color",attrs:{"name":"o_info"}},[_c('q-popup-proxy',[_c('div',{staticClass:"__CPopupInfo-Content"},[_vm._t("default")],2)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }